import { useQuery } from "@tanstack/react-query";
import { portfolioService } from "@/services/portfolioService";

/** Backend v2.1 (Sprint 4.2) Portfolio Read Model - four independent, zero-fabricated-input reads. */
export function useCurrentPortfolio(portfolioId: string) {
  return useQuery({
    queryKey: ["portfolio", "current", portfolioId],
    queryFn: () => portfolioService.getCurrentPortfolio(portfolioId),
  });
}

export function usePortfolioSummary(portfolioId: string) {
  return useQuery({
    queryKey: ["portfolio", "summary", portfolioId],
    queryFn: () => portfolioService.getSummary(portfolioId),
  });
}

export function useHoldings(portfolioId: string) {
  return useQuery({
    queryKey: ["portfolio", "holdings", portfolioId],
    queryFn: () => portfolioService.getHoldings(portfolioId),
  });
}

export function usePositions(portfolioId: string) {
  return useQuery({
    queryKey: ["portfolio", "positions", portfolioId],
    queryFn: () => portfolioService.getPositions(portfolioId),
  });
}
